<template>
  <Card>
    <router-link :to="`../article/${slug}`" class="block group text-inherit no-underline">
      <div class="relative w-full h-48 overflow-hidden rounded-lg mb-4 bg-gray-100">
        <img :src="imageBase64" :alt="title" loading="lazy" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
        <div class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>
      <div class="p-4">
        <h3 class="text-xl font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
          {{ title }}
        </h3>
        <p class="text-gray-600 text-sm line-clamp-3 leading-relaxed">
          {{ description }}
        </p>
      </div>
    </router-link>
  </Card>
</template>

<script>
  import Card from './Card.vue';

  export default {
    name: 'ArticleCard',
    components: { Card },
    props: {
      imageBase64: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: false,
        default: '',
      },
      // 'link' should be provided as the route path using the article slug,
      // e.g. '/article/your-article-slug'
      slug: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped>
  /* Line clamp utilities for text truncation */
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .line-clamp-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>
